import * as React from 'react';

import { AddToCartButtonProvider } from '@sharedComponents/AddToCartButton/context';
import { IAddToCartButtonProps } from '@sharedComponents/AddToCartButton/model';

import { AddToCartCoreComponent } from './AddToCartCoreComponentButton';

type AddToCartButtonWithoutAddToCartModalProps = Omit<
  IAddToCartButtonProps,
  'getModalAfterAddToCart' | 'showAddToCartModal'
>;

export const AddToCartButtonWithoutAddToCartModal: React.FC<AddToCartButtonWithoutAddToCartModalProps> =
  React.memo((props) => {
    const commonProps = {
      showAddToCartModal: false,
      getModalAfterAddToCart: () => void 0,
    };
    return (
      <AddToCartButtonProvider {...props} {...commonProps}>
        <AddToCartCoreComponent {...props} {...commonProps} />
      </AddToCartButtonProvider>
    );
  });
